module.exports = {
  deal_time: {
    type: 10, // 类型：10创建时间，20操作时间
    unit: 50    // 最小单位：10年，20月，30日，40时，50分，60秒
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/dealtime.js